import * as yup from "yup"
import { inputsText } from "schema/login.schema"

const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i

export const poppinsOrderSchema = yup.object({
  keeperEmail: yup
    .string()
    .strict()
    .required(inputsText.REQUIRED_FIELD)
    .test("isEmailValid", inputsText.EMAIL_BAD_FORMAT, value => emailRegex.test(value)),
  description: yup.string().strict(),
  rentalEndDate: yup.string().strict(),
  recipient: yup.object({
    firstName: yup.string().strict().required(inputsText.REQUIRED_FIELD),
    lastName: yup.string().strict().required(inputsText.REQUIRED_FIELD),
    email: yup
      .string()
      .strict()
      .required(inputsText.REQUIRED_FIELD)
      .test("isEmailValid", inputsText.EMAIL_BAD_FORMAT, value => emailRegex.test(value)),
    phone: yup.string().strict(),
  }),
  sender: yup.object({
    firstName: yup.string().strict().required(inputsText.REQUIRED_FIELD),
    lastName: yup.string().strict().required(inputsText.REQUIRED_FIELD),
    email: yup
      .string()
      .strict()
      .required(inputsText.REQUIRED_FIELD)
      .test("isEmailValid", inputsText.EMAIL_BAD_FORMAT, value => emailRegex.test(value)),
    phone: yup.string().strict(),
  }),
})
